<template>

<div><UserGreeting /></div>

  <div class="app-container">
   
    <div class="chip-selector">
  <span class="chip" @click="filterGamesByType('All')" :class="{ selected: selectedtype === '' }">All</span>
  <!-- Example static game types -->
  <span class="chip" @click="filterGamesByType('quiz')" :class="{ selected: selectedtype === 'quiz' }">Quiz</span>
  <span class="chip" @click="filterGamesByType('scenario')" :class="{ selected: selectedtype === 'scenario' }">Scenario</span>
  <span class="chip" @click="filterGamesByType('fill-in-the-blank')" :class="{ selected: selectedtype === 'fill-in-the-blank' }">Fill in the blank</span>
  <span class="chip" @click="filterGamesByType('flashcard')" :class="{ selected: selectedtype === 'flashcard' }">Flashcards</span>
</div>

    <!-- Games Display -->
    <div class="games-display">
      <div
  class="game-card"
  v-for="game in filteredGames"
  :key="game.id"
  @click="startGame(game)"
  :class="{ 'locked': game.locked }"
      >
        <div class="card-header">
          <i :class="`fas ${gameTypeIcon(game.type)}`"></i>
          <span class="game-topic-name">{{ game.topicName }}</span>
          <i 
            class="far fa-heart favorite-icon" 
            :class="{ 'fas': game.isFavorite }" 
            @click.stop="toggleFavorite(game)"
          ></i>
        </div>
        <div class="game-card-image">
  <img :src="game.imageUrl" alt="Game Image">
  <div v-if="game.locked" class="lock-overlay">
    <i class="fas fa-lock"></i>
  </div>
</div>
        <div class="game-card-body">
          <h3>{{ game.title }}</h3>
          <p>{{ game.description }}</p>
          <div class="game-difficulty">
            <i class="fas fa-star" v-for="n in getDifficultyStars(game.difficulty)" :key="n"></i>Level
          </div>
        </div>
      </div>
    </div>
  </div><br><br><br><br><br><br>
</template>

<script>
import { useRouter } from 'vue-router';
import { ref, computed } from 'vue';
import UserGreeting from '@/components/UserGreeting.vue';

export default {
  components: {
    UserGreeting
  },
  setup() {
    const topics = ref([
        { id: 1, name: 'Risk', icon: 'fa-calculator' },
        { id: 2, name: 'Insurance', icon: 'fa-flask' },
        { id: 3, name: 'Savings', icon: 'fa-landmark' },
        { id: 1, name: 'KYC', icon: 'fa-calculator' },
        { id: 2, name: 'Yields', icon: 'fa-flask' },
        { id: 3, name: 'Planning', icon: 'fa-landmark' },
        { id: 1, name: 'Assets', icon: 'fa-calculator' },
        { id: 2, name: 'Wealth Management', icon: 'fa-flask' },
        { id: 3, name: 'Strategies', icon: 'fa-landmark' },
 

        ]);
      const games = ref([

 

        {
          id: 1,
          topicName: 'Foundational',
          type: 'flashcard',
          title: "Canadian Investing Basics",
          description: "",
          imageUrl: "https://assets.codepen.io/11151897/canadiancat_1.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/basics1',
          locked: false,

        },
        {
          id: 2,
          topicName: 'Foundational',
          type: 'flashcard',
          title: "Investment Perspectives",
          description: "",
          imageUrl: "https://assets.codepen.io/11151897/newbiekitten.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/basics2',
          locked: false,

        },

        {
          id: 3,
          topicName: 'Foundational',
          type: 'flashcard',
          title: "Credit Card Terms",
          description: "",
          imageUrl: "https://assets.codepen.io/11151897/creditcardcat.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/basics3',
          locked: false,

        },

        {
          id: 4,
          topicName: 'Foundational',
          type: 'flashcard',
          title: "Canadian Home Rentals",
          description: "",
          imageUrl: "https://assets.codepen.io/11151897/tear-open-package-box-with-beautiful-fluffy-creature-insidecozy-background-cottage-102565038.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/basics4',
          locked: false,

        },


        {
          id: 5,
          topicName: 'Foundational',
          type: 'flashcard',
          title: "Canadian Mortgages",
          description: "",
          imageUrl: "https://assets.codepen.io/11151897/a-gray-cat-in-a-black-suit-stands-next-to-their-mercedes-g-class-car-the-suit-the-cat-is-wearing-is-5171398.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/basics5',
          locked: false,

        },


        {
          id: 6,
          topicName: 'Foundational',
          type: 'quiz',
          title: "Intro to Financial Literacy in Canada",
          description: "",
          imageUrl: "https://assets.codepen.io/11151897/gatitos-estudiando-en-un-aula-con-maestros-924349994.jpeg",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/basics1c',
          locked: false,

        },

        {
          id: 7,
          topicName: 'Foundational',
          type: 'quiz',
          title: "Intro to Investing in Canada",
          description: "",
          imageUrl: "https://assets.codepen.io/11151897/one-eyed-cyborg-anthropomorphic-tuxedo-cat-red-suit-side-typing-on-golden-plated-laptop-and-tradi-57094060.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/basics3c',
          locked: false,

        },

        {
          id: 8,
          topicName: 'Foundational',
          type: 'quiz',
          title: "Intro to ETF Investing",
          description: "",
          imageUrl: "https://assets.codepen.io/11151897/photo-of--a-cute-cat-wearing-a-suit--on-a-busy-street-long-shothighly-detailed-trending-on-a-613878563.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/basics4c',
          locked: false,

        },

        {
          id: 9,
          topicName: 'Foundational',
          type: 'quiz',
          title: "Intro to Mutual Funds",
          description: "",
          imageUrl: "https://assets.codepen.io/11151897/two-or-more-cats-with-executive-dressed-looking-at-a-cv-it-needs-to-look-professional-and-business--340662315.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/basics5c',
          locked: false,

        },

        {
          id: 10,
          topicName: 'Foundational',
          type: 'quiz',
          title: "Intro to Stocks",
          description: "",
          imageUrl: "https://assets.codepen.io/11151897/one-eyed-cyborg-anthropomorphic-tuxedo-cat-red-suit-side-typing-on-golden-plated-laptop-and-tradi-688828315.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/basics6c',
          locked: false,

        },

        {
          id: 11,
          topicName: 'Foundational',
          type: 'quiz',
          title: "Intro to Guaranteed Investment Certificates (GICs)",
          description: " ",
          imageUrl: "https://assets.codepen.io/11151897/cat-using-calculator-604200506.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/basics7c',
          locked: false,

        },

        {
          id: 12,
          topicName: 'Foundational',
          type: 'flashcard',
          title: "Understanding Market-Linked GICs",
          description: "",
          imageUrl: "https://assets.codepen.io/11151897/stock-market-848123023.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/basics8c',
          locked: false,

        },

        {
          id: 13,
          topicName: 'Foundational',
          type: 'quiz',
          title: "Intro to Mortgages in Canada",
          description: "",
          imageUrl: "https://assets.codepen.io/11151897/a-gray-cat-in-a-black-suit-stands-next-to-their-mercedes-g-class-car-the-suit-the-cat-is-wearing-is-887346820+%281%29.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/basics9c',
          locked: false,

        },

        {
          id: 14,
          topicName: 'Foundational',
          type: 'quiz',
          title: "Understanding Credit Cards",
          description: "",
          imageUrl: "https://assets.codepen.io/11151897/cinematic-screaming-sharp-focus-cuteness-overload-hyperrealistic-19th-century-mary-blair-alex-654344590.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/basics10c',
          locked: false,

        },

        {
          id: 15,
          topicName: 'Foundational',
          type: 'fill-in-the-blank',
          title: "Intro to Financial Literacy",
          description: "",
          imageUrl: "https://assets.codepen.io/11151897/catsstudying.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/basic1b',
          locked: false,

        },
        {
          id: 16,
          topicName: 'Foundational',
          type: 'scenario',
          title: "Foundational Investing in Canada",
          description: "",
          imageUrl: "https://assets.codepen.io/11151897/cinematic-screaming-sharp-focus-cuteness-overload-hyperrealistic-19th-century-mary-blair-alex-654344590.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/basics1d',
          locked: false,

        },

      {
          id: 20,
          topicName: 'Risk',
          type: 'flashcard',
          title: "Risks Terms 101 ",
          description: "Don't be afraid of risks. Assess, Prevent and Mitigate Instead",
          imageUrl: "https://assets.codepen.io/11151897/cat-in-gotham-haze-ultra-detailed-film-photography-light-leaks-larry-bud-melman-trending-on-ar-463861029.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/risk1',
          locked: true,

        },
        {
          id: 21,
          topicName: 'Risk',
          type: 'flashcard',
          title: "Risk Terms 102",
          description: "Solve challenging puzzles to master math skills.",
          imageUrl: "https://assets.codepen.io/11151897/blackcatfilingnails.gif",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/risk2',
          locked: true,

        },
  
      
        {
          id: `100`,
          topicName: 'Wealth Management',
          type: 'quiz',
          title: "Short Squeeze",
          description: "Do you know the risks of short selling?",
          imageUrl: "https://assets.codepen.io/11151897/catsqueeze.gif",
          difficulty: "intermediate",
          isFavorite: false,
          route: '/games/menu',
          locked: true,

        },
        {
          id: 110,
          topicName: 'Strategies',
          type: 'quiz',
          title: "Options Trading",
          description: "Calls, Puts and Implied Volatility - test your skills",
          imageUrl: "https://assets.codepen.io/11151897/Catsagain.png",
          difficulty: "advanced",
          isFavorite: false,
          route: '/games/menu',
          locked: true,

        },
       
        {
          id: 21,
          topicName: 'Wealth Management',
          type: 'quiz',
          title: "Futures Trading 101",
          description: "From farmers to oil producers futures has a major impact.",
          imageUrl: "https://assets.codepen.io/11151897/catconfused.gif",
          difficulty: "expert",
          isFavorite: false,
          route: '/games/menu',
          locked: true,

        },
        
        // Add more games as needed
        ]);
   
        const slider = ref(null);
        const selectedtype = ref('');

        const filteredGames = computed(() => {
      if (!selectedtype.value || selectedtype.value === 'All') {
        return games.value;
      } else {
        return games.value.filter(game => game.type === selectedtype.value);
      }
    });

    const gameTypeIcon = (type) => {
      switch (type) {
        case 'quiz': return 'fa-question-circle';
        case 'scenario': return 'fa-users';
        case 'fill-in-the-blank': return 'fa-pencil-alt';
        case 'flashcard': return 'fa-images';
        default: return 'fa-gamepad';
      }
    };

    const toggleFavorite = (game) => {
      game.isFavorite = !game.isFavorite;
    };

    const filterGamesByType = (type) => {
      selectedtype.value = type === 'All' ? '' : type; // Corrected to use selectedType
    };

    const router = useRouter();

    const startGame = (game) => {
  if (!game.locked && game.route) {
    router.push(game.route);
  }
};
    const getDifficultyStars = (difficulty) => {
      switch (difficulty) {
        case 'beginner':
          return 1;
        case 'intermediate':
          return 2;
        case 'advanced':
          return 3;
        case 'expert':
          return 4;
        default:
          return 0; // No stars if difficulty level is undefined
      }
    };
    const scrollLeft = () => {
      if(slider.value) {
        slider.value.scrollLeft -= 200;
      }
    };

    const scrollRight = () => {
      if(slider.value) {
        slider.value.scrollLeft += 200;
      }
    };


    return {
      topics,
      games,
      filteredGames,
      filterGamesByType,
      gameTypeIcon,
      toggleFavorite,
      scrollLeft,
      scrollRight,
      startGame,
      getDifficultyStars,
      UserGreeting,

    };
  }
};
</script>

<style scoped>
.app-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}


.locked {
  filter: grayscale(100%); /* Grey out locked games */
  cursor: not-allowed; /* Change cursor to indicate it's not interactable */
  pointer-events: none; /* Prevent clicking on the card */
}
.games-display {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  width: 100%;
  padding: 20px;
}

.game-card {
  position: relative; 
  width: 250px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
}

.game-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: linear-gradient(135deg, #36454f 0%, #5a6978 50%, #b0bec5 100%);
  color: white;
}

.game-card-image img {
  width: 100%;
  height: 150px;
  object-fit: cover;
}
.lock-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5); /* semi-transparent overlay */
  color: white; /* Lock icon color */
  font-size: 24px; /* Lock icon size */
}
.game-card-body {
  padding: 10px;
  text-align: left;
}

.game-difficulty {
  display: flex;
  justify-content: flex-end; /* Aligns difficulty stars to the right */
  padding: 5px 10px;
  
}
.chip-selector {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  padding: 10px 0;
  
}

.chip {
  background-color: #f1f1f1;
  padding: 8px 16px;
  border-radius: 25px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.chip.selected {
  background-color: #4A148C;
  color: white;
}
.favorite-icon {
  cursor: pointer;
}

/* Responsive Design */
@media (max-width: 768px) {
  .game-card {
    width: calc(70% - 20px); /* Adjust for smaller screens */
  }
}

@media (max-width: 480px) {
  .topics-slider-container {
    width: 100%;
  }

  .game-card {
    width: 100%; /* Full width on very small screens */
    margin: 10px 0;
  }
}
</style>